// src/pages/TransferRecord/TransferRecordThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../apiservice/apis";
import { formatToCompanyTimezone } from "../../lib/functions";

export const fetchTransferRecord = createAsyncThunk(
  "transferRecord/fetch",
  async (
    { selectedFilterType, selectedRecordType, filters },
    { rejectWithValue }
  ) => {
    try {
      let url = "/inventory/get-transfer-record";
      if (selectedRecordType === "with item") {
        url = "/inventory/get-transfer-record-with-details";
      }

      const payload = {
        selectedFilterType: selectedFilterType || null,
        // selectedRecordType: selectedRecordType || null,
        userId:
          selectedFilterType === "By User" ? filters.userId || null : null,
        itemId:
          selectedFilterType === "By Item" ? filters.itemId || null : null,
        groupId:
          selectedFilterType === "By Group" ? filters.groupId || null : null,
        categoryId:
          selectedFilterType === "By Category"
            ? filters.categoryId || null
            : null,
        toBranchId:
          selectedFilterType === "By Branch" ? filters.branchId || null : null,
        fromDate: filters.fromDate || null,
        toDate: filters.toDate || null,
      };

      const res = await postData(url, payload);

      let mapped = [];
      if (selectedRecordType === "with item") {
        mapped = res.data.flatMap((tr) =>
          tr.details.map((item, idx) => ({
            id: `${tr.t_id}-${item.item_id}-${idx}`,
            t_id: tr.t_id,
            vch_no: tr.t_voucher_no,
            date: formatToCompanyTimezone(tr.created_date).split(" ")[0],
            branch: tr.to_branch_name,
            createdBy: tr.full_name,
            item: item.item_name,
            qty: `${item.item_qty} ${item.unit_name || ""}`,
            rate: Number(item.item_rate || 0).toFixed(2),
            total: Number(item.item_total || 0).toFixed(2),
            unitDetails: `Master U. Qty = ${item.item_qty}, Base U. Qty = ${item.retail_qty}, Total = ${item.item_total}`,
          }))
        );
      } else {
        mapped = res.data.map((row) => ({
          id: row.t_id,
          t_id: row.t_id,
          vch_no: row.t_voucher_no,
          date: formatToCompanyTimezone(row.created_date).split(" ")[0],
          branch: row.to_branch_name,
          createdBy: row.full_name,
          transport_cost: Number(row.transport_cost || 0).toFixed(2),
          total: Number(row.total_amount || 0).toFixed(2),
          status: row.status === 'p' ? "Pending" : "Active",
        }));
      }

      return mapped;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


export const deleteTransfer = createAsyncThunk(
  "transferRecord/delete",
  async (t_id, { rejectWithValue }) => {
    try {
      const res = await postData("/inventory/transfer-delete", { t_id });
      return { t_id, message: res.data.message };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);